import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { useSharingTools } from '../../../../hooks/useSharingTools';
import { SharingToolsCardWrapper } from '../../../SharingToolsCardWrapper';
import { SocialContentPreview } from '../SocialContentPreview';

export const SocialContentCard: React.FC = () => {
	const { data, actions } = useSharingTools();

	return (
		<SharingToolsCardWrapper
			Preview={<SocialContentPreview isLoading={data.shareVisual.isLoading} shareVisual={data.shareVisual.image} />}
			titleKey={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.social_content.title')}
			descriptionKey={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.social_content.description')}
			primaryActionTextKey={translationKey(
				'corgi.petition.starter_dashboard_v2.sharing_tools.social_content.primary_action_text',
			)}
			primaryActionOnClick={actions.navigateToShareVisual}
		/>
	);
};
